"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[8117],{

/***/ 6676
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class ByoProductCardController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static values = {
    productId: String,
    productHandle: String,
    hideModalCta: Boolean,
    lowInventory: Boolean,
    inStock: Boolean,
  }
  static outlets = ['byo']
  static targets = [
    'lowInventoryBadge',
    'lowInventoryText',
    'productCardTag',
    'imageContainer',
    'imageBackground',
    'outOfStockBadge',
  ]

  inStockValueChanged() {
    if (this.inStockValue) {
      this.imageBackgroundTarget.classList.remove('opacity-25')
      this.outOfStockBadgeTarget.classList.add('hidden')
      if (this.hasProductCardTagTarget) {
        this.productCardTagTarget.classList.remove('hidden')
      }
    } else {
      this.imageContainerTarget.style.removeProperty('background')
      this.imageBackgroundTarget.classList.add('opacity-25')
      this.outOfStockBadgeTarget.classList.remove('hidden')
      if (this.hasProductCardTagTarget) {
        this.productCardTagTarget.classList.add('hidden')
      }
    }
  }

  lowInventoryValueChanged() {
    if (this.lowInventoryValue) {
      this.lowInventoryBadgeTarget.classList.remove('hidden')
      this.lowInventoryTextTarget.classList.remove('hidden')
      if (this.hasProductCardTagTarget) {
        this.productCardTagTarget.classList.add('hidden')
      }
    } else {
      this.lowInventoryBadgeTarget.classList.add('hidden')
      this.lowInventoryTextTarget.classList.add('hidden')
      if (this.hasProductCardTagTarget) {
        this.productCardTagTarget.classList.remove('hidden')
      }
    }
  }

  openProductModal() {
    this.byoOutlet.openProductModal(this.productIdValue, this.productHandleValue, this.hideModalCtaValue)
  }
}

Stimulus.register('byo-product-card', ByoProductCardController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(6676)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);